var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"illustration"},[_c('b-img',{attrs:{"fluid":"","src":_vm.src,"alt":"Page illustration"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }